__turbopack_context__.v({
  "heroTitle": "HeroTitle-module__SrnfUa__heroTitle",
  "largeHeroTitle": "HeroTitle-module__SrnfUa__largeHeroTitle",
  "largeHeroTitleContainer": "HeroTitle-module__SrnfUa__largeHeroTitleContainer",
  "largeHeroTitleFirstOverlay": "HeroTitle-module__SrnfUa__largeHeroTitleFirstOverlay",
  "largeHeroTitleSecondOverlay": "HeroTitle-module__SrnfUa__largeHeroTitleSecondOverlay",
  "largeHeroTitleText": "HeroTitle-module__SrnfUa__largeHeroTitleText",
  "largeHeroTitleThirdOverlay": "HeroTitle-module__SrnfUa__largeHeroTitleThirdOverlay",
  "mediumHeroTitle": "HeroTitle-module__SrnfUa__mediumHeroTitle",
  "mediumHeroTitleContainer": "HeroTitle-module__SrnfUa__mediumHeroTitleContainer",
  "mediumHeroTitleFirstOverlay": "HeroTitle-module__SrnfUa__mediumHeroTitleFirstOverlay",
  "mediumHeroTitleSecondOverlay": "HeroTitle-module__SrnfUa__mediumHeroTitleSecondOverlay",
  "mediumHeroTitleText": "HeroTitle-module__SrnfUa__mediumHeroTitleText",
  "mediumHeroTitleThirdOverlay": "HeroTitle-module__SrnfUa__mediumHeroTitleThirdOverlay",
  "smallHeroTitle": "HeroTitle-module__SrnfUa__smallHeroTitle",
  "smallHeroTitleContainer": "HeroTitle-module__SrnfUa__smallHeroTitleContainer",
  "smallHeroTitleFirstOverlay": "HeroTitle-module__SrnfUa__smallHeroTitleFirstOverlay",
  "smallHeroTitleSecondOverlay": "HeroTitle-module__SrnfUa__smallHeroTitleSecondOverlay",
  "smallHeroTitleText": "HeroTitle-module__SrnfUa__smallHeroTitleText",
  "smallHeroTitleThirdOverlay": "HeroTitle-module__SrnfUa__smallHeroTitleThirdOverlay",
});
